import { CodeHighlighterTheme } from "@/utils/CodeHighlighter";
import { ThemeMeta } from ".";

import "./far.css";

export default <ThemeMeta>{
  highlight: CodeHighlighterTheme.TomorrowNight,
  editor: "tomorrow-night"
};
